module.exports = __webpack_public_path__ + "static/media/2_13.210f6550.png";